
    import './styles.scoped.css';
    export default {
  "resize-active": "awsui_resize-active_x7peu_p6la0_9",
  "resize-active-with-focus": "awsui_resize-active-with-focus_x7peu_p6la0_9",
  "resizer-wrapper": "awsui_resizer-wrapper_x7peu_p6la0_14",
  "resizer-button-wrapper": "awsui_resizer-button-wrapper_x7peu_p6la0_23",
  "divider": "awsui_divider_x7peu_p6la0_27",
  "divider-interactive": "awsui_divider-interactive_x7peu_p6la0_28",
  "divider-grouped": "awsui_divider-grouped_x7peu_p6la0_46",
  "divider-position-top": "awsui_divider-position-top_x7peu_p6la0_50",
  "divider-position-bottom": "awsui_divider-position-bottom_x7peu_p6la0_56",
  "divider-position-full": "awsui_divider-position-full_x7peu_p6la0_62",
  "divider-active": "awsui_divider-active_x7peu_p6la0_72",
  "is-borderless": "awsui_is-borderless_x7peu_p6la0_76",
  "is-last": "awsui_is-last_x7peu_p6la0_76",
  "visual-refresh": "awsui_visual-refresh_x7peu_p6la0_80",
  "resizer": "awsui_resizer_x7peu_p6la0_14",
  "has-focus": "awsui_has-focus_x7peu_p6la0_129",
  "tracker": "awsui_tracker_x7peu_p6la0_151"
};
  